module.exports = __webpack_public_path__ + "img/icon19.15172ef4.png";